import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby'

function QualityAssuranceReportList (props) {
    const data = useStaticQuery(graphql`
        query QualityAssuranceReportQuery {
            reports: allNodeQualityAssuranceReports(
            sort: [{field_qar_year: DESC}, {title: ASC}]
            ) {
            edges {
                node {
                field_qar_year
                title
                relationships {
                    field_qar_file {
                    localFile {
                        publicURL
                    }
                    }
                }
                }
            }
            }
        }
    `)

    const reports = data.reports.edges;

    function getYears() {
        const current_year = new Date().getFullYear();

        let years = [];
        for (let i = current_year -4; i <= current_year; i++) {
            years.unshift(i);
        }

        return years;
    }

    function filter_reports(reports, year) {
        const yearly_reports = reports.filter(report => report.node.field_qar_year === year);
        return yearly_reports;
    }

    function render_reports(reports) {
        return reports.map(report => {
            return (<li>
                <Link to={report.node.relationships.field_qar_file.localFile.publicURL} dangerouslySetInnerHTML={{__html: report.node.title}} />
            </li>);
        });
    }

    function render_lists(years, reports) {
        const results = years.map((year) => {
            const rendered_reports = render_reports(filter_reports(reports, year));

            if(rendered_reports.length === 0 ) {
                return <></>;
            }

            return (<>
                <h3>{year}</h3>
                <ul>{rendered_reports}</ul>
            </>)
        });       

        return results;
    }

    const years = getYears();
    const rendered_lists = render_lists(years, reports);

    return (<>
        <h2>Library Quality Assurance Reports</h2>
        <>{rendered_lists}</>
    </>)
       
}

export default QualityAssuranceReportList